import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgReviewCardMobileSkeleton = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 367 220"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={367} height={220} rx={6} fill="#fff" />
    <path
      fill="#E6E9ED"
      d="M8 28h180v1H8zM57 55h80v1H57zM57 72h150v1H57zM8 132h206v1H8zM8 206h150v1H8zM8 100h343v1H8zM8 164h316v1H8zM8 148h343v1H8zM8 116h316v1H8zM8 180h343v1H8z"
    />
    <circle cx={28} cy={60} r={20} fill="#E6E9ED" />
  </svg>
);
const Memo = memo(SvgReviewCardMobileSkeleton);
export default Memo;
